// @flow
import React from 'react';
import { css } from 'react-emotion';
import { Link } from 'react-router-dom';
import Header from './subcomponents/Header';
import logo from 'assets/images/app_logo.svg';
import { connect } from 'react-redux';

class PanelWrapper extends React.Component {
  constructor() {
    super();
    this.state = {
      open: true
    };
  }

  toggle = () => {
    this.setState(p => ({
      open: !p.open
    }));
  };

  render() {
    const { open } = this.state;
    const { children, user } = this.props;

    return (
      <div className="body body-wrapper">
        <div className="body-wrapper-inner">
          <nav className="nav-leftpanel">
            <div className="app-logo-container">
              <Link to="/">
                <img src={logo} alt="" />
                <p className="user-company-name" >{ user.company }</p>
              </Link>
            </div>
            <div className="nav-leftpanel--links-list" id="left-panel-portal">
            {/* data passed by portal */}
              {/* <div className="nav-leftpanel--ll-item">
                <div className="nav-leftpanel--ll-heading">
                  <a href="">
                    <span className="nav-leftpanel--icon">
                      <img src="images/i4.svg " />
                    </span>
                    <span>Katalog Produktów</span>
                  </a>
                </div>
              </div>
              <div className="nav-leftpanel--ll-item">
                <div className="nav-leftpanel--ll-heading">
                  <a href="">
                    <span className="nav-leftpanel--icon">
                      <img src="images/i21.svg" />
                    </span>
                    <span>Historia zamówień</span>
                  </a>
                </div>
              </div>
              <div className="nav-leftpanel--ll-item">
                <div className="nav-leftpanel--ll-heading">
                  <a href="">
                    <span className="nav-leftpanel--icon">
                      <img src="images/i51.svg" />
                    </span>
                    <span>Profil Firmy</span>
                  </a>
                </div>
              </div>
              <div className="nav-leftpanel--ll-item">
                <div className="nav-leftpanel--ll-heading">
                  <a href="">
                    <span className="nav-leftpanel--icon">
                      <img src="images/i3.svg" />
                    </span>
                    <span>Lista Użytkowników</span>
                  </a>
                </div>
              </div> */}
            </div>
          </nav>
          <div className={`main-content-wrapper ${open ? '' : closedContent}`}>
            <Header open={open} toggle={this.toggle}/>
            <div className="main-content-wrapper--inner">{children}</div>
          </div>
        </div>
      </div>
    );
  }
}

function mapState(state) {
  return {
    user: state.auth.user
  };
}
export default connect(mapState)(PanelWrapper);

const closedContent = css`
  margin-left: 20px;
  width: calc(100% - 20px);
`;


// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/PanelWrapper.jsx